import React, {Component} from 'react';
import styled from '@emotion/styled';
import {Global, css} from '@emotion/react';
import {colors} from '@atlaskit/theme';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';

import Column from './Column';
import backgroundImage from '../images/transp_bg.png';

const ParentContainer = styled.div`
  height: ${({height}) => height};
  overflow-x: hidden;
  overflow-y: auto;
`;

const Container = styled.div`
  /* background-color: ${colors.B100}; */
  background-image: url(${backgroundImage});
  /* min-height: 100vh; */
  min-height: calc(100vh - 96px); /* 96 is header height */
  /* like display:flex but will allow bleeding over the window width */
  min-width: 100vw;
  display: inline-flex;
  margin-top: 10px;
`;

export default class Board extends Component {
  onDragEnd = (result) => {
    // dropped nowhere
    if (!result.destination) {
      return;
    }

    const source = result.source;
    const destination = result.destination;

    // did not move anywhere - bail early
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return;
    }

    // reordering columns
    if (result.type === 'COLUMN') {
      const ordered = reorder(this.props.columnOrder, source.index, destination.index);

      this.props.handleUpdateColumnOrder(ordered);
      return;
    }

    const data = reorderColumnWords({
      columns: this.props.columns,
      source,
      destination,
    });

    this.props.handleUpdateColumns(data.columns);
  };

  render() {
    const {
      columns,
      columnOrder,
      containerHeight,
      withScrollableColumns,
      handleOnChangeSound,
      handleDeleteWord,
      isEditable,
    } = this.props;

    const board = (
      <Droppable
        droppableId="board"
        type="COLUMN"
        direction="horizontal"
        ignoreContainerClipping={Boolean(containerHeight)}
      >
        {(provided) => (
          <Container ref={provided.innerRef} {...provided.droppableProps}>
            {columnOrder.map((key, index) => (
              <Column
                key={key}
                index={index}
                column={columns[key]}
                isScrollable={withScrollableColumns}
                handleOnChangeSound={handleOnChangeSound}
                handleClickDeleteWord={handleDeleteWord}
                isEditable={isEditable}
              />
            ))}
            {provided.placeholder}
          </Container>
        )}
      </Droppable>
    );

    return (
      <React.Fragment>
        <DragDropContext onDragEnd={this.onDragEnd}>
          {containerHeight ? <ParentContainer height={containerHeight}>{board}</ParentContainer> : board}
        </DragDropContext>
        <Global
          styles={css`
            body {
              background: white;
            }
          `}
        />
      </React.Fragment>
    );
  }
}

// help with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const reorderColumnWords = ({columns, source, destination}) => {
  const current = [...columns[source.droppableId].words];
  const next = [...columns[destination.droppableId].words];
  const target = current[source.index];

  // moving to same list
  if (source.droppableId === destination.droppableId) {
    const reordered = reorder(current, source.index, destination.index);
    const result = {
      ...columns,
      [source.droppableId]: {
        ...columns[source.droppableId],
        words: reordered,
      },
    };
    return {
      columns: result,
    };
  }

  // moving to different list

  // remove from original
  current.splice(source.index, 1);
  // insert into next
  next.splice(destination.index, 0, target);

  const result = {
    ...columns,
    [source.droppableId]: {
      ...columns[source.droppableId],
      words: current,
    },
    [destination.droppableId]: {
      ...columns[destination.droppableId],
      words: next,
    },
  };

  return {
    columns: result,
  };
};
